export default __webpack_public_path__ + "static/sarpl-team-logo-small-a2765d7437c970ae3a85c55247a444eb.png";